import { Editor, Text, Transforms } from "slate";

import normalizeUrl from "./normalizeUrl";

const insertLink = (editor: Editor, url: string, name: string = url): void => {
  // TODO: Remove ?? url after TART-21760 implementation
  const normalizedUrl = normalizeUrl(url)?.toString() ?? url;

  Editor.addMark(editor, "link", normalizedUrl);

  const [link] = Editor.nodes(editor, {
    match: (n) => !Editor.isEditor(n) && Text.isText(n) && !!n.link,
  });

  const textNode = link?.[0] ?? { link: normalizedUrl, text: name };
  if (Text.isText(textNode)) {
    Transforms.insertNodes(editor, [{ ...textNode, text: name }, { text: "" }]);
  }
};

export default insertLink;
